import createSelector from "../../Utils/reselect";

const journeyStateData = (state) => {
  const { journey } = state;
  return journey || {};
};

export const getJourneySessionsList = createSelector(
  journeyStateData,
  (journey) => {
    const list = journey.get("sessionsList");
    return list && typeof list.toJS === "function" ? list.toJS() : list;
  }
);

export const getJourneySessionsLoading = createSelector(
  journeyStateData,
  (journey) => journey.get("loading") || false
);

export const getJourneySessionDetail = createSelector(
  journeyStateData,
  (journey) => {
    const detail = journey.get("sessionDetail");
    return detail && typeof detail.toJS === "function" ? detail.toJS() : detail;
  }
);

export const getJourneyDetailLoading = createSelector(
  journeyStateData,
  (journey) => journey.get("detailLoading") || false
);

export const getJourneyMoreLoading = createSelector(
  journeyStateData,
  (journey) => journey.get("moreLoading") || false
);

export const getJourneyActiveUsers = createSelector(
  journeyStateData,
  (journey) => journey.get("activeUsers") || null
);

export const getJourneyError = createSelector(
  journeyStateData,
  (journey) => journey.get("error") || null
);
